import { Box, Button } from "@mui/material";

import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";

import { CREATED_CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT, isTemplateCreated } from "../../constant";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { useCarouselFunctions } from "../../utils/useCarouselFunctions";
import IconsColor from "../../../../utility/iconsColor";
import TouchTooltip from "../../utils/TouchTooltip";

const CarouselTemplateAddCardPreview = (props: any) => {

    const { handleAddNewCard } = props;

    const { checkDisableAddBtnForCarouselMax10Cards } = useCarouselFunctions();
    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);

    const isAddCardDisabled = isTemplateCreated(createTemplatePayload) || checkDisableAddBtnForCarouselMax10Cards();

    const renderAddCardButton = () => {
        const addCardButton = (
            <Button
                variant="contained"
                disableElevation
                onClick={() => handleAddNewCard?.()}
                className={styles.addButton}
                disabled={isAddCardDisabled}
                style={{ opacity: isAddCardDisabled ? 0.5 : 1, width: "100%", maxWidth: "87%" }}
                startIcon={<IconsColor iconName="plus" width="12px" height="12px" fillColor="#1B7D4E" />}
            >
                Add Card
            </Button>
        );

        if (isTemplateCreated(createTemplatePayload)) {
            return (
                <TouchTooltip title={CREATED_CAROUSEL_TEMPLATE_ADD_CARD_TOOLTIP_TEXT} >
                    <span className={globalStyles.clickable}>
                        {addCardButton}
                    </span>
                </TouchTooltip>
            );
        }

        return addCardButton;
    };

    return (
        <Box className={`${globalStyles.marginTop10px} ${styles.buttonsActionsDisabledCursor}`}>
            {renderAddCardButton()}
        </Box>
    )
}

export default CarouselTemplateAddCardPreview;